module.exports = __webpack_public_path__ + "static/media/tip.dc87c82c.svg";